import { Component, OnInit, EventEmitter } from "@angular/core";
import { DatacheckService } from "src/app/services/datacheck.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  UploadOutput,
  UploadInput,
  UploadFile,
  humanizeBytes,
  UploaderOptions,
} from "ngx-uploader";
import { Sharedservice } from "./../../shared-components/shared.service";
import { environment } from "src/environments/environment";
import { UserService } from "src/app/services/user.service";
import { UserModel } from "src/app/models/user.model";
import { MessageService } from "primeng/api";
import { FlatfileService } from "src/app/services/flatfile.service";
import { SignflipParamModel } from "src/app/models/flatfile.model";
import {
  severitymessage,
  FunctionalityNames,
  LanguageConstants,
} from "../../shared-components/constant";
import { EngagementService } from "src/app/services/engagement.service";
import { saveAs } from "file-saver";
import { ErrorPopUpModel } from "../../models/errorpopup.model";
import { AuditingService } from "src/app/services/auditing.service";
import { WebJobQueueService } from "src/app/services/webjobqueue.service";
import { WebJobQueueModel } from "src/app/models/webJobQueue.model";
import { InfraService } from "src/app/services/infra.service";
import { RegionsEnum, TemplateEnum } from "src/app/enums/regions.enum";
import { AccountingCalendarEnum } from "../../enums/accounting-calendar.enum";
import { PeriodService } from "../../services/period.service";
import { PeriodPreferenceModel } from "../../models/period-preference.model";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { LanguageHelperService } from "../../services/language.helper.service";
import { formatNumber } from "@angular/common";
import { forkJoin } from "rxjs";
import { EngagementModel } from "src/app/models/engagement.model";
import { MasterHelpService } from "src/app/services/masterhelp.service";
import { AppConfigurationService } from "./../../services/appConfiguration.service";
import { AppConfigurationsModel } from "./../../models/appConfigurations.model";
import { Observable } from "rxjs";
@Component({
  selector: "app-performdatacheck",
  templateUrl: "./performdatacheck.component.html",
  styleUrls: ["./performdatacheck.component.css"],
})
export class PerformdatacheckComponent implements OnInit {
  show = false;
  uploadInput: EventEmitter<UploadInput>;
  sourceFiles: UploadFile[];
  public pagerows: number;
  public pagerowsBS: number;
  isEngagementReadOnly: boolean = false;
  signflipParamModel: SignflipParamModel[];
  cols: any[];
  colsBS: any[];
  checkAllBS: boolean;
  checkAll: boolean;
  AuditCheckCols: any[];
  AuditCheckDetails: any[];
  isSelectedAllPL: boolean;
  isSelectedAllBS: boolean;
  frozenCols: any[];
  private loggedInId: number;
  humanizeBytes: Function;
  options: UploaderOptions;
  private engagementId: number = parseInt(
    this.route.snapshot.paramMap.get("id")
  );
  flatFileStepId: number;
  public engagement: EngagementModel;
  private flatUpload_url: string;
  templateId: number;
  selectedRegionId: number;
  errorModel: ErrorPopUpModel = new ErrorPopUpModel();
  private maxsize = environment.maxFileSize * 1024 * 1024;
  private maxFlatFileSizeUploadLimit =
    environment.maxFlatFileSizeUploadLimit * 1024 * 1024;
  private minFlatFileSizeToSendEmail = environment.minFlatFileSizeToSendEmail;
  plugNetIncomeYears = [];
  timeOutHandler: NodeJS.Timer;
  timeOutHandlerFlatFileDownload: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  isTimeIntervalInProgressFlatFileDownload = false;
  webJobQueueId: number;
  flatFileDownloadWebJobQueueId: number;
  regionId: number;
  currentengagementTemplateId: number;
  accountDetails: any[] = [];
  accountDetailsBS: any[] = [];
  flipDisabled = false;
  gridMessage = "";
  checkedItemsBS = "";
  checkedItemsPL = "";
  entityvalues: any[];
  entityfilteredval: any[];
  confirmdisplay = false;
  selectedEntityID = 0;
  loadspinner = false;
  loadspinnerflatfile = false;
  loadspinnerflatfileupload = false;
  loadspinnerdownloadmapping = false;
  isTempFlatfileUploaded: number;
  flatfile: any;
  engagementName: string = null;
  isPnP: boolean;
  isCustomizedEngagement: boolean;
  isPLGridVisible = false;
  isBSGridVisible = false;
  notificationDisplay = false;
  isTemplateEndDateMismatch = false;
  isAssessmentEndDateMismatch = false;
  isTemplate = false;
  isAssessment = false;
  accountingCalendarId = 0;
  isFlatfileTemplateUploaded = true;
  isPreferredSourceEndDate = true;
  isEndDateMismatch = false;
  isOtherIncExpIncluded = false;
  isLocalCopyUploaded = false;
  forUSTemplate: string;
  forROWTemplate: string;
  forTotalCostTemplate: string;
  currLangTranslation: any;
  langCode: string;
  nextStep: any;
  previousStep: any;
  db_langCode: string;
  db_currLangTranslation: any;
  isToggleEnabled: boolean = false;
  maxMonth: number;
  maxYear: number;
  EXCEL_CONTENT_TYPE: string =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  bsData :any[];
  constructor(
    private datacheckService: DatacheckService,
    private route: ActivatedRoute,
    private appConfigService: AppConfigurationService,
    public router: Router,
    public sharedService: Sharedservice,
    private userService: UserService,
    private messageService: MessageService,
    private flatfileService: FlatfileService,
    private flatFileService: FlatfileService,
    private engagementservice: EngagementService,
    private auditingService: AuditingService,
    private webJobQueueService: WebJobQueueService,
    private infraService: InfraService,
    private periodService: PeriodService,
    private translateService: TranslateService,
    private http: HttpClient,
    private languageHelper: LanguageHelperService,
    private masterHelpService: MasterHelpService
  ) {
    this.flatFileStepId = 7;
    this.isEngagementReadOnly =
      this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
    this.infraService.infraDetails$.subscribe((data) => {
      if (data !== undefined) {
        this.flatUpload_url =
          data.WebEndPoint2 + "flatfile/AddFlatFileToQueue/";
        this.selectedRegionId = data.InfraId;
        this.templateId = data.TemplateId;
        this.engagementName = localStorage.getItem(
          "currentEngagement" + this.engagementId + this.selectedRegionId
        );
        console.log(localStorage.getItem("currentEngagementTemplateId"),'localstorage');
        this.currentengagementTemplateId = parseInt(
          localStorage.getItem(
            "currentEngagementTemplateId" + data.InfraId + this.engagementId
          ),
          10
        );
        this.isTempFlatfileUploaded =
          this.sharedService.getLocalStorageValueByName(
            "isTempFlatfileUploaded" + this.engagementId + data.InfraId
          );
      }
    });

    this.options = {
      concurrency: 1,
      allowedContentTypes: [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel.sheet.macroEnabled.12",
      ],
    };

    this.sourceFiles = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInId = userData.Id;
      }
    });
  }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.db_langCode = localStorage.getItem(`db_lang_code${this.engagementId}`);
    this.accountingCalendarId = parseInt(
      localStorage.getItem("CurrentAccountCalenderId" + this.engagementId),
      10
    );
    this.getCurrentEngagementDetails();
    this.forUSTemplate = this.currLangTranslation.step7.forUSTemplate;
    this.forROWTemplate = this.currLangTranslation.step7.forROWTemplate;
    this.forTotalCostTemplate =
      this.currLangTranslation.step7.forTotalCostTemplate;
    this.nextStep = this.currLangTranslation.actionButtons.nextStep;
    this.previousStep = this.currLangTranslation.actionButtons.previousStep;

    // this.engagementservice
    //   .getEngagement(this.engagementId)
    //   .subscribe((data: EngagementModel) => {
    //     //this.engagement.isPnP = data.isPnP;
    //     this.engagement = data;
    //   });

    if (this.isTempFlatfileUploaded === 1) {
      if (
        this.engagementservice.engModel.IsPnP &&
        this.engagementservice.engModel.TemplateId != 3 && this.engagementservice.engModel.AccCalendarId  === 1
      )
        this.sharedService.setactiveindex(4);
      else this.sharedService.setactiveindex(3);
    } else {
      this.sharedService.setactiveindex(6);
    }
    this.pagerows = environment.pageRows;
    this.pagerowsBS = environment.pageRows;
    this.fetchdatacheck_LeadPL(this.engagementId);

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.langCode = langEvent.lang;
        this.currLangTranslation = langEvent.translations;
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        this.forUSTemplate = this.currLangTranslation.step7.forUSTemplate;
        this.forROWTemplate = this.currLangTranslation.step7.forROWTemplate;
        this.forTotalCostTemplate =
          this.currLangTranslation.step7.forTotalCostTemplate;
        this.fetchdatacheck_LeadPL(this.engagementId);
      }
    );
  }

  fetchdatacheck_LeadPL(entityId: number) {
    this.loadspinner = true;
    this.datacheckService.getDataCheckDataPL(entityId).subscribe(
      (response: any) => {
        this.fetchdatacheck_LeadBS(this.engagementId);
        const result = response;
        if (result.status === "success") {
          this.cols = [];
          this.isPLGridVisible = result.headers.length > 0;
          this.maxYear = +result.maxYear;
          this.maxMonth = +result.maxMonth;
          result.headers
            .map((item) => {
              return {
                fieldname: item,
              };
            })
            .forEach((item: any) => {
              this.cols.push({
                field:
                  item.fieldname.charAt(0).toLowerCase() +
                  item.fieldname.slice(1),
                header: this.getheadernamebyFY(item.fieldname),
                visible: true,
                isEditable: false,
              });
            });

          this.accountDetails = result.data;
        } else {
          this.gridMessage = "Error while executing request";
        }
      },
      (err) => {
        this.fetchdatacheck_LeadBS(this.engagementId);
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  fetchdatacheck_LeadBS(entityId: number) {
    this.loadspinner = true;
    this.datacheckService.getDataCheckDataBS(entityId).subscribe(
      (response: any) => {
        const result = response;
        if (result.status === "success") {
          this.colsBS = [];
          this.isBSGridVisible = result.headers.length > 0;
          result.headers
            .map((item) => {
              return {
                fieldname: item,
              };
            })
            .forEach((item: any) => {
              this.colsBS.push({
                field:
                  item.fieldname.charAt(0).toLowerCase() +
                  item.fieldname.slice(1),
                header: this.getHeaderNameForBS(item.fieldname),
                visible: true,
                isEditable: false,
              });
            });

          this.accountDetailsBS = result.data;
          this.bsData = result.bsData;
          this.frozenCols = [
            { field: "NetValue", header: "NetValue" },
            { field: "StandardizedMapping", header: "Accounts" },
          ];

          if (this.accountDetailsBS.length > 0) {
            this.getAuditCheckData();
          } else {
            this.colsBS = [];
          }
          this.loadspinner = false;
        } else {
          this.gridMessage = "Error while executing request";
          this.loadspinner = false;
        }
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  public getAuditCheckData() {
    if (this.engagementservice.engModel.IsCustomizedEngagement) {
      this.AuditCheckCols = this.colsBS;
            this.AuditCheckCols = this.AuditCheckCols.filter((auditElement) => {
              if (/\d/.test(auditElement.field)) {
                // get only those columns who has Numbers in it - getting only year columns
                return auditElement;
              }
            });
            this.AuditCheckCols.unshift({
              field: "totalAssetsLessTotalLiabilitiesEquity",
              header: "",
              visible: true,
              isEditable: false,
            });
            this.AuditCheckDetails = this.bsData;
      }
    else{
      this.plugNetIncomeYears = [];
      this.AuditCheckCols = this.colsBS;
  
      this.AuditCheckCols = this.AuditCheckCols.filter((auditElement) => {
        if (/\d/.test(auditElement.field)) {
          // get only those columns who has Numbers in it - getting only year columns
          return auditElement;
        }
      });
  
      const totalAssetsObj = this.accountDetailsBS.filter(
        (p) => p.standardizedMapping === "Total assets"
      );
      const liabilitiesObj = this.accountDetailsBS.filter(
        (p) => p.standardizedMapping === "Total liabilities"
      );
      const equitiesObj = this.accountDetailsBS.filter(
        (p) => p.standardizedMapping === "Equity"
      );
      const shareHolderEquityObj = this.accountDetailsBS.filter(
        (p) => p.standardizedMapping === "Shareholders equity"
      );
  
      const auditObj = {
        DataCheck: "Total assets less total liabilities & equity",
      };
      let year = 0;
      this.AuditCheckCols?.forEach((fiscalYearColumn) => {
        var fiscalYearColField;
        if (!this.isNumber(fiscalYearColumn.field))
          fiscalYearColField =
            fiscalYearColumn.field.charAt(0) + fiscalYearColumn.field.slice(1);
        else
          fiscalYearColField =
            fiscalYearColumn.field.charAt(0).toLowerCase() +
            fiscalYearColumn.field.slice(1);
        const assetValue = this.getExtractedNumberFromData(
          this.languageHelper.cleanNumber(
            totalAssetsObj[0][fiscalYearColField],
            this.db_langCode
          )
        );
        const liabilityValue = this.getExtractedNumberFromData(
          this.languageHelper.cleanNumber(
            liabilitiesObj[0][fiscalYearColField],
            this.db_langCode
          )
        );
        const equityValue = this.getExtractedNumberFromData(
          this.languageHelper.cleanNumber(
            equitiesObj[0][fiscalYearColField],
            this.db_langCode
          )
        );
        if(shareHolderEquityObj.length > 0){
          var shareHolderEquity = this.getExtractedNumberFromData(
            this.languageHelper.cleanNumber(
              shareHolderEquityObj[0][fiscalYearColField],
              this.db_langCode
            )
          );
        }
        
  
        if (this.currentengagementTemplateId === TemplateEnum.Americas) {
          auditObj[fiscalYearColumn.field] =
            assetValue - (liabilityValue + equityValue);
        } else {
          auditObj[fiscalYearColumn.field] =
            assetValue + (liabilityValue + shareHolderEquity);
        }
        // If BS Audit check is NOT zero & same as "Net Income" from Lead PL enable "plug net income to retained earnings"
        if (this.accountDetails.length > 0) {
          year =
            year === 0
              ? fiscalYearColumn.field.match(/\d+/g).map(Number)[0]
              : year + 1;
          if (auditObj[fiscalYearColumn.field] !== 0) {
            this.plugNetIncomeYears.push(year);
          }
        }
      });
      this.AuditCheckCols.unshift({
        field: "DataCheck",
        header: "",
        visible: true,
        isEditable: false,
      });
      this.AuditCheckDetails = [auditObj];
    } 
  }

  getFormattedNumber(plainNumber: any, languageCode: string) {
    let isNegative = false;
    let inputValue = plainNumber;
    if (!isNaN(plainNumber)) {
      if (plainNumber && plainNumber !== "-") {
        isNegative = !(+plainNumber > 0);
        plainNumber = new Intl.NumberFormat(languageCode).format(plainNumber); // formatNumber(plainNumber, languageCode, '1.2-2');
      }
      if (!isNegative) return plainNumber;
      else return `(${+inputValue * -1})`;
    } else return plainNumber;
  }

  private getExtractedNumberFromData(columnValue: any) {
    if (columnValue) {
      // Checks for -ve values & removes Thousand seperator.
      if (columnValue.indexOf("(") >= 0) {
        columnValue =
          parseInt(
            columnValue.replace("(", "").replace(")", "").replace(/,/g, "")
          ) * -1;
      } else if (columnValue === "-") {
        columnValue = 0;
      } else {
        columnValue = parseInt(columnValue.replace(/,/g, ""));
      }
    }
    return columnValue;
  }

  approveClick(event: any) {
    this.messageService.clear();
    this.router.navigate(["/engagement/", this.engagementId, "schedules"]);
  }

  refreshsignflip() {
    this.loadspinner = true;
    if (this.flipDisabled) {
      this.signflipParamModel = [];
      this.signflipParamModel.push({
        EngagementId: this.engagementId,
        mappingitemBS: this.checkedItemsBS,
        mappingitemPL: this.checkedItemsPL,
      });
      this.flatfileService
        .updatemappingwithsignflip(this.engagementId, this.signflipParamModel)
        .subscribe(
          (response: any) => {
            if (response.message === severitymessage.success) {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.success,
                summary: this.currLangTranslation.severitymessage.notification,
                detail:
                  this.currLangTranslation.step7.signflipSuccessMessage
                    .SuccessMessage.SignflipUpdation,
                sticky: true,
                closable: true,
              });

              this.fetchdatacheck_LeadPL(this.engagementId);
              this.checkedItemsBS = "";
              this.checkedItemsPL = "";
              this.flipDisabled = false;
              this.selectallPL(false);
              this.selectallBS(false);
            }
          },
          (error) => {
            this.loadspinner = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        );
      this.auditingService
        .addAudit(this.engagementId, FunctionalityNames.SignFlip)
        .subscribe();
    }
  }

  downloadToexcel() {
    this.loadspinner = true;
    forkJoin([
      this.engagementservice.getEngagement(this.engagementId),
      this.datacheckService.getdataCheckExcel(
        this.engagementId,
        this.templateId
      ),
    ]).subscribe((results: any) => {
      this.loadspinner = false;
      const enggModel: EngagementModel = results[0];
      const fileContent = results[1];
      let downloadfileName = enggModel.EngagementName;
      const today = new Date();
      let todayDateString: any;
      if (fileContent) {
        this.http
          .get(`../assets/i18n/${enggModel.LanguageCode}.json`)
          .subscribe((i18n: any) => {
            if (
              enggModel.TemplateId === 0 ||
              enggModel.TemplateId === TemplateEnum.Americas
            ) {
              todayDateString =
                ("0" + (today.getMonth() + 1)).slice(-2) +
                ("0" + today.getDate()).slice(-2) +
                today.getFullYear();
              downloadfileName +=
                `_${i18n.labels.downloadDataCheckSuffixName}_` +
                `${todayDateString}.xlsx`;
            } else {
              todayDateString =
                ("0" + today.getDate()).slice(-2) +
                ("0" + (today.getMonth() + 1)).slice(-2) +
                today.getFullYear();
              downloadfileName +=
                `_${i18n.labels.downloadDataCheckSuffixName}_` +
                `${todayDateString}.xlsx`;
            }
            this.masterHelpService.downloadFileByBlob(
              fileContent,
              downloadfileName,
              this.EXCEL_CONTENT_TYPE
            );
          });
      } else {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    });
  }

  downloadToflatefile() {
    this.loadspinnerflatfile = true;
    this.flatFileService
      .addFlatFileDownloadIntoQueue(this.engagementId)
      .subscribe((queueId: any) => {
        this.auditingService
          .addAudit(this.engagementId, FunctionalityNames.FlatFileDownload)
          .subscribe();
        this.flatFileDownloadWebJobQueueId = queueId.id;
        this.checkFlatFileDownloadProcessed();
      });
  }

  checkFlatFileDownloadProcessed() {
    this.webJobQueueService
      .getWebJobQueue(this.flatFileDownloadWebJobQueueId)
      .subscribe(
        (resp: WebJobQueueModel) => {
          if (resp) {
            if (!resp.isQueued) {
              this.isTimeIntervalInProgressFlatFileDownload = false;
              clearInterval(this.timeOutHandlerFlatFileDownload);
              if (resp.isError) {
                this.loadspinnerflatfile = false;
                if (resp.responseText === "") {
                  this.messageService.add({
                    key: this.currLangTranslation.severitymessage.key,
                    severity: severitymessage.error,
                    summary:
                      this.currLangTranslation.severitymessage.notification,
                    detail:
                      this.currLangTranslation.severitymessage.somethingwrong,
                    sticky: true,
                    closable: true,
                  });
                } else {
                  this.errorModel.confirmIsDisplay = true;
                  this.errorModel.displayMessage = resp.responseText;
                }
              } else {
                this.downloadFlatFile();
              }
            } else {
              if (!this.isTimeIntervalInProgressFlatFileDownload) {
                this.timeOutHandlerFlatFileDownload = setInterval(() => {
                  this.isTimeIntervalInProgressFlatFileDownload = true;
                  this.loadspinnerflatfile = true;
                  this.checkFlatFileDownloadProcessed();
                }, environment.webjobTimer);
              }
            }
          } else {
            this.loadspinnerflatfile = false;
            this.isTimeIntervalInProgressFlatFileDownload = false;
            clearInterval(this.timeOutHandlerFlatFileDownload);
          }
        },
        (err) => {
          this.loadspinnerflatfile = false;
          this.isTimeIntervalInProgressFlatFileDownload = false;
          clearInterval(this.timeOutHandlerFlatFileDownload);
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  downloadFlatFile() {
    this.loadspinnerflatfile = true;
    const today = new Date();
    let todayDateString;
    let fileName = this.engagementName;

    if (this.templateId === TemplateEnum.Americas) {
      todayDateString =
        ("0" + (today.getMonth() + 1)).slice(-2) +
        ("0" + today.getDate()).slice(-2) +
        today.getFullYear();
      fileName += "_FlatFile_" + `${todayDateString}.xlsx`;
    } else {
      todayDateString =
        ("0" + today.getDate()).slice(-2) +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        today.getFullYear();
      fileName += "_FlatFile_" + `${todayDateString}.xlsx`;
    }

    this.flatFileService
      .getflatfile(this.flatFileDownloadWebJobQueueId)
      .subscribe(
        (blobData) => {
          this.loadspinnerflatfile = false;
          if (blobData) {
            saveAs(blobData, fileName);
          } else {
            this.loadspinnerflatfile = false;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        },
        (err) => {
          this.loadspinnerflatfile = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  getHeaderNameForBS(headervalue: string) {
    if (headervalue === "StandardizedMapping") {
      return "Accounts";
    } else if (headervalue !== "NetValue") {
      return (
        this.languageHelper.convertMonthToLocale(
          this.langCode,
          headervalue.substring(0, 3)
        ) + headervalue.substring(3, headervalue.length)
      );
    }
     else {
      return headervalue;
    }
  }
	
  getheadernamebyFY(headervalue: string) {
    if (this.isNumber(headervalue)) {
      if (headervalue.length === 2) {
        return this.currLangTranslation.step7.fy + headervalue;
      } else {
        if (this.currentengagementTemplateId == 1) {
          if (this.accountingCalendarId === AccountingCalendarEnum.P13) {
            if (this.maxYear === +headervalue && this.maxMonth != 13)
              return (
                this.maxMonth +
                "p" +
                headervalue.substring(2, headervalue.length)
              );
            else
              return (
                this.currLangTranslation.step7.fy +
                headervalue.substring(2, headervalue.length)
              );
          } else {
            if (this.maxYear === +headervalue && this.maxMonth != 12)
              return (
                this.maxMonth +
                "m" +
                headervalue.substring(2, headervalue.length)
              );
            else
              return (
                this.currLangTranslation.step7.fy +
                headervalue.substring(2, headervalue.length)
              );
          }
        } else {
          if (this.accountingCalendarId === AccountingCalendarEnum.P13) {
            if (this.maxYear === +headervalue && this.maxMonth != 13)
              return (
                this.maxMonth +
                "p" +
                headervalue.substring(2, headervalue.length) +
                "A"
              );
            else
              return (
                this.currLangTranslation.step7.fy +
                headervalue.substring(2, headervalue.length) +
                "A"
              );
          } else {
            if (this.maxYear === +headervalue && this.maxMonth != 12)
              return (
                this.maxMonth +
                "m" +
                headervalue.substring(2, headervalue.length) +
                "A"
              );
            else
              return (
                this.currLangTranslation.step7.fy +
                headervalue.substring(2, headervalue.length) +
                "A"
              );
          }
        }
      }
    } else {
      if (headervalue === "StandardizedMapping") {
        return "Accounts";
      }
    }
    return headervalue;
  }

  onUploadOutput(output: UploadOutput, fileInput: any): void {
    if (output.type === "allAddedToQueue") {
      if (this.sourceFiles.length > 0) {
        const event: UploadInput = {
          type: "uploadAll",
          url:
            this.flatUpload_url +
            `${this.engagementId}\\${this.flatFileStepId}`,
          method: "POST",
          data: { loggedInUserId: <any>this.loggedInId },
          headers: {
            Authorization:
              "Bearer " +
              (environment.isBearerAuthorizationEnabled
                ? localStorage["dbamsaltoken"]
                : environment.sampleToken),
          },
        };
        this.uploadInput.emit(event);
      }
    } else if (
      output.type === "addedToQueue" &&
      typeof output.file !== "undefined"
    ) {
      if (output.file.size > this.maxFlatFileSizeUploadLimit) {
        this.loadspinnerflatfileupload = false;
        fileInput.value = "";
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.severitymessage.MaxsizeError +
          " " +
          output.file.name +
          "  " +
          " of size more than " +
          environment.maxFlatFileSizeUploadLimit +
          " MB";
      } else {
        this.sourceFiles.push(output.file);
      }
    } else if (
      output.type === "uploading" &&
      typeof output.file !== "undefined"
    ) {
      this.loadspinnerflatfileupload = true;
      // update current data in sourceFiles array for uploading file
      const index = this.sourceFiles.findIndex(
        (file) =>
          typeof output.file !== "undefined" && file.id === output.file.id
      );
      this.sourceFiles[index] = output.file;
    } else if (output.type === "done" && typeof output.file !== "undefined") {
      // Validating file type from server
      if (
        output.file &&
        output.file.response &&
        output.file.response.message === "Invalid File Format"
      ) {
        this.loadspinnerflatfileupload = false;
        fileInput.value = "";
        this.uploadInput.emit({ type: "remove", id: output.file.id });
        this.errorModel.confirmIsDisplay = true;
        this.errorModel.displayMessage =
          this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
        return;
      }

      // update current data in sourceFiles array for uploading file
      if (this.sourceFiles[0].responseStatus === 400) {
        if (this.sourceFiles[0].response.statusId === 422) {
          // 422 status id means queue is already present for flatfileupload
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.headerTitle = "Notification";
          this.errorModel.displayMessage =
            this.currLangTranslation.step7.performdatacheckComponentMessage.ErrorMessage.QueueInProgress;
          this.loadspinnerflatfileupload = false;
        } else {
          this.loadspinnerflatfileupload = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.FormateError,
            sticky: true,
            closable: true,
          });
        }
      } else {
        if (this.sourceFiles[0].response.status === severitymessage.success) {
          this.webJobQueueId = this.sourceFiles[0].response.id;
          if (
            this.sourceFiles[0].size / 1024 >=
            this.minFlatFileSizeToSendEmail
          ) {
            this.loadspinnerflatfileupload = false;
            this.notificationDisplay = true;
          } else {
            this.checkFlatFileProcessed();
          }
        } else if (
          this.sourceFiles[0].response.message &&
          this.sourceFiles[0].response.message !== ""
        ) {
          this.loadspinnerflatfileupload = false;
          this.errorModel.confirmIsDisplay = true;
          this.errorModel.displayMessage = this.sourceFiles[0].response.message;
        } else {
          this.loadspinnerflatfileupload = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail:
              this.currLangTranslation.downloadUploadFlatfileComponentmessage
                .ErrorMessage.UploadSummary,
            sticky: true,
            closable: true,
          });
        }
      }
      this.sourceFiles = [];
      // Clear file - to upload same file name twice
      fileInput.value = "";
    } else if (
      output.type === "rejected" &&
      typeof output.file !== "undefined"
    ) {
      this.errorModel.confirmIsDisplay = true;
      this.errorModel.displayMessage =
        this.currLangTranslation.uploadSourcefilemessage.errorMessage.FormateError;
      fileInput.value = "";
      this.loadspinnerflatfileupload = false;
    } else if (output.type === "removed") {
      // remove file from array when removed
      this.sourceFiles = this.sourceFiles.filter(
        (file: UploadFile) => file !== output.file
      );
      this.loadspinnerflatfileupload = false;
    } else if (output.type === "dragOver") {
    } else if (output.type === "dragOut") {
    } else if (output.type === "drop") {
    }
  }

  populateSuggestionsForFlatFile() {
    this.router.navigate(["/engagement/", this.engagementId, "remediation"], {
      queryParams: { from: "datacheck" },
    });
  }

  private checkFlatFileProcessed() {
    this.webJobQueueService.getWebJobQueue(this.webJobQueueId).subscribe(
      (resp: WebJobQueueModel) => {
        if (resp) {
          if (!resp.isQueued) {
            this.loadspinnerflatfileupload = false;
            this.isTimeIntervalInProgress = false;
            clearInterval(this.timeOutHandler);
            if (resp.isError) {
              if (resp.responseText === "") {
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.error,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail:
                    this.currLangTranslation.severitymessage.somethingwrong,
                  sticky: true,
                  closable: true,
                });
              } else {
                // Shows multiple validation messages.
                this.errorModel.confirmIsDisplay = true;
                this.errorModel.displayMessage = resp.responseText.split("@@");
              }
            } else {
              if (resp.isSMMissing) {
                this.populateSuggestionsForFlatFile();
              } else {
                const rowsUploadedMsg =
                  resp.noOfRowsUploaded +
                  " " +
                  this.currLangTranslation
                    .downloadUploadFlatfileComponentmessage.SuccessMessage
                    .RowsUploaded;
                this.messageService.add({
                  key: this.currLangTranslation.severitymessage.key,
                  severity: severitymessage.success,
                  summary:
                    this.currLangTranslation.severitymessage.notification,
                  detail: rowsUploadedMsg,
                  sticky: true,
                  closable: true,
                });

                if (
                  this.accountingCalendarId === AccountingCalendarEnum.P445 ||
                  this.accountingCalendarId === AccountingCalendarEnum.P454 ||
                  this.accountingCalendarId === AccountingCalendarEnum.P544
                ) {
                  this.periodService
                    .isDatacheckEndDateMismatchExist(this.engagementId)
                    .subscribe(
                      (dt) => {
                        if (dt != null) {
                          if (
                            dt.isMismatch === true &&
                            dt.isPreferredSourceEndDate === ""
                          ) {
                            this.isEndDateMismatch = true;
                          } else if (dt.isMismatch === true) {
                            if (this.isPreferredSourceEndDate) {
                              if (this.isFlatfileTemplateUploaded)
                                this.isTemplate = true;
                              else this.isAssessment = true;
                            } else if (this.isPreferredSourceEndDate == false) {
                              if (this.isFlatfileTemplateUploaded)
                                this.isTemplateEndDateMismatch = true;
                              else this.isAssessmentEndDateMismatch = true;
                            }
                          }
                        }
                      },
                      (err) => {
                        this.loadspinner = false;
                        this.messageService.add({
                          key: this.currLangTranslation.severitymessage.key,
                          severity: severitymessage.error,
                          summary:
                            this.currLangTranslation.severitymessage
                              .notification,
                          detail:
                            this.currLangTranslation.severitymessage
                              .somethingwrong,
                          sticky: true,
                          closable: true,
                        });
                      }
                    );
                }
                this.fetchdatacheck_LeadPL(this.engagementId);
                this.checkedItemsBS = "";
                this.checkedItemsPL = "";
                this.flipDisabled = false;
                this.selectallPL(false);
                this.selectallBS(false);
              }
            }
          } else {
            if (!this.isTimeIntervalInProgress) {
              this.timeOutHandler = setInterval(() => {
                this.isTimeIntervalInProgress = true;
                this.loadspinnerflatfileupload = true;
                this.checkFlatFileProcessed();
              }, environment.webjobTimer);
            }
          }
        } else {
          if (!this.isTimeIntervalInProgress) {
            this.timeOutHandler = setInterval(() => {
              this.isTimeIntervalInProgress = true;
              this.loadspinnerflatfileupload = true;
              this.checkFlatFileProcessed();
            }, environment.webjobTimer);
          }
        }
      },
      (err) => {
        this.loadspinnerflatfileupload = false;
        this.isTimeIntervalInProgress = false;
        clearInterval(this.timeOutHandler);
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: "cancel", id: id });
  }

  removeFile(id: string): void {
    this.uploadInput.emit({ type: "remove", id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: "removeAll" });
  }

  closeEventFlatFile($event) {
    this.confirmdisplay = $event;
  }

  addCheckedItemPL(item: string, isChecked: boolean) {
    if (isChecked) {
      if (this.checkedItemsPL === "") {
        this.checkedItemsPL = item;
      } else {
        this.checkedItemsPL = this.checkedItemsPL + "~" + item;
      }
    } else {
      if (this.checkedItemsPL.split("~").length <= 1) {
        this.checkedItemsPL = this.checkedItemsPL.replace(item, "");
      } else {
        this.checkedItemsPL = this.checkedItemsPL.replace("~" + item, "");
      }
    }

    if (this.checkedItemsPL === "" && this.checkedItemsBS === "") {
      this.flipDisabled = false;
    } else {
      this.flipDisabled = true;
    }
  }

  addCheckedItemBS(item: string, isChecked: boolean) {
    if (isChecked) {
      if (this.checkedItemsBS === "") {
        this.checkedItemsBS = item;
      } else {
        this.checkedItemsBS = this.checkedItemsBS + "~" + item;
      }
    } else {
      if (this.checkedItemsBS.split("~").length <= 1) {
        this.checkedItemsBS = this.checkedItemsBS.replace(item, "");
      } else {
        this.checkedItemsBS = this.checkedItemsBS.replace("~" + item, "");
      }
    }

    if (this.checkedItemsPL === "" && this.checkedItemsBS === "") {
      this.flipDisabled = false;
    } else {
      this.flipDisabled = true;
    }
  }

  cancelDataCheck() {
    this.confirmdisplay = true;
    this.messageService.clear();
  }

  isNumber(n: any) {
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n);
  }

  closeEventworkallocation($event) {
    this.confirmdisplay = $event;
  }

  previousButton() {
    this.confirmdisplay = false;
    this.router.navigate(["/engagement/", this.engagementId, "remediation"]);
  }

  selectallPL(isChecked: boolean) {
    this.checkAll = true;
    if (isChecked) {
      this.isSelectedAllPL = true;
      const plFilter = this.accountDetails.filter((x) => x.netValue === '0' || x.netValue === 0);

      for (let i = 0; i < plFilter.length; i++) {
        if (this.checkedItemsPL === "") {
          this.checkedItemsPL = "~" + plFilter[i].standardizedMapping;
        } else {
          this.checkedItemsPL =
            this.checkedItemsPL + "~" + plFilter[i].standardizedMapping;
        }
      }
      if (this.checkedItemsPL === "" && this.checkedItemsBS === "") {
        this.flipDisabled = false;
      } else {
        this.flipDisabled = true;
      }
    } else {
      this.checkAll = false;
      this.isSelectedAllPL = false;
      this.checkedItemsPL = "";

      if (this.checkedItemsPL === "" && this.checkedItemsBS === "") {
        this.flipDisabled = false;
      } else {
        this.flipDisabled = true;
      }
    }
  }

  updateSelectallPL() {
    this.accountDetails.forEach((item) => {
      if (item.isSelectedAllPL) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    });
  }

  selectallBS(isChecked: boolean) {
    this.checkAllBS = true;
    if (isChecked) {
      this.isSelectedAllBS = true;
      const bsFilter = this.accountDetailsBS.filter((x) => x.netValue === '0' || x.netValue === 0);
      for (let i = 0; i < bsFilter.length; i++) {
        if (this.checkedItemsBS === "") {
          this.checkedItemsBS = "~" + bsFilter[i].standardizedMapping;
        } else {
          this.checkedItemsBS =
            this.checkedItemsBS + "~" + bsFilter[i].standardizedMapping;
        }
      }
      if (this.checkedItemsPL === "" && this.checkedItemsBS === "") {
        this.flipDisabled = false;
      } else {
        this.flipDisabled = true;
      }
    } else {
      this.checkAllBS = false;
      this.isSelectedAllBS = false;
      this.checkedItemsBS = "";
      if (this.checkedItemsPL === "" && this.checkedItemsBS === "") {
        this.flipDisabled = false;
      } else {
        this.flipDisabled = true;
      }
    }
  }

  updateSelectallBS() {
    this.accountDetailsBS.forEach((item) => {
      if (item.isSelectedAllBS) {
        this.checkAllBS = true;
      } else {
        this.checkAllBS = false;
      }
    });
  }

  DownloadMappingclick(event: any) {
    this.loadspinnerdownloadmapping = true;
    forkJoin([
      this.engagementservice.getEngagement(this.engagementId),
      this.flatFileService.getMappingfile(this.engagementId),
    ]).subscribe((results: any) => {
      this.loadspinnerdownloadmapping = false;
      const enggModel: EngagementModel = results[0];
      const fileContent = results[1];
      const today = new Date();
      let todayDateString: any;
      let downloadfileName = enggModel.EngagementName;
      if (fileContent) {
        this.http
          .get(`../assets/i18n/${enggModel.LanguageCode}.json`)
          .subscribe((i18n: any) => {
            if (
              enggModel.TemplateId === 0 ||
              enggModel.TemplateId === TemplateEnum.Americas
            ) {
              todayDateString =
                ("0" + (today.getMonth() + 1)).slice(-2) +
                ("0" + today.getDate()).slice(-2) +
                today.getFullYear();
              downloadfileName +=
                `_${i18n.labels.downloadManualMappingSuffixName}_` +
                `${todayDateString}.xlsx`;
            } else {
              todayDateString =
                ("0" + today.getDate()).slice(-2) +
                ("0" + (today.getMonth() + 1)).slice(-2) +
                today.getFullYear();
              downloadfileName +=
                `_${i18n.labels.downloadManualMappingSuffixName}_` +
                `${todayDateString}.xlsx`;
            }
            saveAs(fileContent, downloadfileName);
          });
      } else {
        this.loadspinnerdownloadmapping = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    });
  }

  savePlugNetIncome() {
    this.loadspinner = true;
    this.datacheckService
      .UpdatePlugNetIncome(
        this.engagementId,
        this.plugNetIncomeYears,
        this.currentengagementTemplateId
      )
      .subscribe(
        (data) => {
          if (data["status"] === "success") {
            const status: boolean = data["message"] === "True";
            this.fetchdatacheck_LeadPL(this.engagementId);
            this.checkedItemsBS = "";
            this.checkedItemsPL = "";
            this.selectallPL(false);
            this.selectallBS(false);
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.success,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: status
                ? this.currLangTranslation.step7
                    .performdatacheckComponentMessage.RetainedEarnings.Success
                    .plugMessage
                : this.currLangTranslation.step7
                    .performdatacheckComponentMessage.RetainedEarnings.Success
                    .unplugMessage,
              sticky: true,
              closable: true,
            });
          }
        },
        (err) => {
          this.loadspinner = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
    this.auditingService
      .addAudit(this.engagementId, FunctionalityNames.PLugUnplug)
      .subscribe();
  }

  getCurrentEngagementDetails() {
    this.engagementservice.getEngagement(this.engagementId).subscribe(
      (data) => {
        if (data !== null) {
          this.db_langCode = data.LanguageCode;

          if (this.db_langCode === this.langCode) {
            this.db_currLangTranslation = JSON.parse(
              JSON.stringify(this.currLangTranslation)
            );
          } else {
            this.http
              .get(`../assets/i18n/${data.LanguageCode}.json`)
              .subscribe((i18n) => {
                this.db_currLangTranslation = i18n;
              });
          }
          this.engagementName = data.EngagementName;
          this.templateId = data.TemplateId;
          this.accountingCalendarId = data.AccCalendarId;
          this.isFlatfileTemplateUploaded = data.IsFlatfileTemplateUploaded;
          this.isPreferredSourceEndDate = data.IsPreferredSourceEndDate;
          //this.isPnP = data.isPnP;
          this.isCustomizedEngagement = data.IsCustomizedEngagement;
          this.isLocalCopyUploaded =
            data.IsLocalCopyUploaded == null ? false : data.IsLocalCopyUploaded;
          this.isOtherIncExpIncluded = data.IsOtherIncExpIncluded;
          localStorage.setItem(
            "currentEngagement" + this.engagementId + data.TemplateId,
            data.EngagementName
          );
        } else {
          this.loadspinnerdownloadmapping = false;
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      },
      (err) => {
        this.loadspinnerdownloadmapping = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  OkNotificationDisplay() {
    this.notificationDisplay = false;
    this.isAssessmentEndDateMismatch = false;
    this.isTemplateEndDateMismatch = false;
    this.isTemplate = false;
    this.isAssessment = false;
  }

  endDateBasedOnTemplate = "0";
  endDateMismatchBtnClick() {
    const periodPreferenceModel = new PeriodPreferenceModel();
    periodPreferenceModel.EngagementId = this.engagementId;
    periodPreferenceModel.PeriodPreference =
      this.endDateBasedOnTemplate === "1";
    periodPreferenceModel.QueueIdentifier = 16; // Queueid for CapIQFromFlatfile
    if (periodPreferenceModel.PeriodPreference)
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.EndDateBasedOnSourceFile
        )
        .subscribe();
    else
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.EndDateBasedOnProjectInput
        )
        .subscribe();

    this.periodService.UpdatePeriodPreference(periodPreferenceModel).subscribe(
      () => {
        this.isEndDateMismatch = false;
        if (this.endDateBasedOnTemplate === "1") {
          this.notificationDisplay = true;
        }
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  onToggleSwitch() {
    this.isToggleEnabled = !this.isToggleEnabled;
    if (!this.isLocalCopyUploaded) {
      this.loadspinner = true;
      this.datacheckService
        .UpdateOtherIncExp(this.engagementId, this.isOtherIncExpIncluded)
        .subscribe(
          (data) => {
            if (data["message"] === "success") {
              this.fetchdatacheck_LeadPL(this.engagementId);
            } else {
              this.loadspinner = false;
              this.isOtherIncExpIncluded = !this.isOtherIncExpIncluded;
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail: this.currLangTranslation.severitymessage.somethingwrong,
                sticky: true,
                closable: true,
              });
            }
          },
          (err) => {
            this.loadspinner = false;
            this.isOtherIncExpIncluded = !this.isOtherIncExpIncluded;
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key,
              severity: severitymessage.error,
              summary: this.currLangTranslation.severitymessage.notification,
              detail: this.currLangTranslation.severitymessage.somethingwrong,
              sticky: true,
              closable: true,
            });
          }
        );
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.OtherIncomeAddedToEBITDA
        )
        .subscribe();
    }
  }

  redirectPlugandPlay() {
    this.router.navigate(["/engagement/", this.engagementId, "layout"]);
  }
}
